import { gql } from '@apollo/client';

export default gql`
  query partnerContactCategories {
    partnerContactCategories {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`;
